<template>
  <div
    class="pie-chart-card"
    ref="demographicsPieChart"
  >
    <Tile class="insights-card">
      <Loader :loading="loading" :error="showError">
        <TileContent
          :title="card.title"
          :tooltip="card.tooltip"
          @iconClick="emitIconClick"
        >
          <template v-slot:chart>
            <ReportMessage
              v-if="showThresholdMessage"
              class="threshold-message"
              :message="thresholdMessage"
            />
            <PieChartBlock
              v-else
              :data="data"
              :hasTooltip="true"
              :height="381"
              :chartWidth="381"
              :wrapperWidth="wrapperWidth"
              :radius="190"
              class="insights-pie-chart"
            />
          </template>
        </TileContent>
      </Loader>
    </Tile>
  </div>
</template>

<script>
import { insightsCardsMap } from '../../../dashboard/Views/config/insightsCards';
import Loader from '../../Common/Charting/Shared/Loader';
import PieChartBlock from '../../Common/Charting/Shared/Charts/PieChartBlock';
import ReportMessage from '../../Common/ReportMessage.vue';
import Tile from '../../Common/Tile.vue';
import TileContent from '../../Common/TileContent.vue';

export default {
  props: {
    data: {
      type: Array,
    },
    error: {
      type: Boolean,
    },
    isExternalData: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
    },
    shouldBlurValues: {
      type: Boolean,
    },
    showThresholdMessage: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Loader,
    PieChartBlock,
    ReportMessage,
    Tile,
    TileContent,
  },
  data() {
    return {
      card: insightsCardsMap.gender,
      pieChartWidth: 500,
      wrapperWidth: 500,
      pieWidthRate: 0.8,
      thresholdMessage: {
        title: 'Not Enough Data',
        description: [
          'The number of page views doesn\'t meet MikMak\'s minimum threshold.',
          'Please modify your report filters or date range to view a larger data set.',
        ],
        tip: '',
        action: {},
        isAlert: true,
        isNewReport: false,
      },
    };
  },
  computed: {
    showError() {
      return (this.error || !this.data || this.data.length === 0)
        && !this.showThresholdMessage;
    },
  },
  methods: {
    handleResize() {
      const chart = this.$refs.demographicsPieChart;

      this.pieChartWidth = this.pieWidthRate * chart.clientWidth;

      this.wrapperWidth = this.$refs.demographicsPieChart.offsetWidth;
    },
    emitIconClick() {
      if (this.shouldBlurValues) {
        return;
      }

      this.$emit('iconClick', this.card.title);
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  mounted() {
    this.handleResize();
  },
};
</script>

<style lang="scss" scoped>
.pie-chart-card {
  flex: 1;
}

::v-deep {
  & .threshold-message .report-message {
    width: 500px;
  }
}

.threshold-message {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%)
}

.insights-card {
  min-width: 400px;
  height: 400px;
  position: relative;
    .badge {
      position: absolute;
      left: 16px;
      bottom: 11px;
    }
    .title {
      color: #223448;
      font-size: 18px;
      font-weight: 700;
      font-family: Lato;
      position: absolute;
      top: 17px;
      left: 16px;
    }
    .insights-pie-chart-label {
      position: absolute;
      right: 24px;
      top: 60px;
      padding-top: 24px;
    }
  }

@media (min-width: 862px) and (max-width: 1010px) {
  .insights-card {
    .insights-pie-chart-label {
      right: 12px;
    }
  }
  ::v-deep {
    & .threshold-message .report-message {
      width: 350px;
    }
  }
}
</style>
